
const m = window.require("discourse/lib/dom-from-string");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
